import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// GROUNDING: docs/visual-companion/2026-05-24-honest-reality-check.html (phase scorecard),
// docs/presentation-eakc-shipped-2026-06-01.md (🟢/🟡/🔵 legend),
// docs/visual-companion/2026-05-28-graph-brain-and-base-hardening-plan.html (G0–G12 roadmap),
// docs/hermes/EAKC_HERMES_EVOLUTION.md §19 (genuinely-live list, 521+ tests).

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "I audited my own AI product and marked three things “shipped” that did nothing at runtime." },
];

export const AUDIT: ScriptLine[] = [
  { scene: "audit", fromSec: 0.4, holdSec: 6, caption: "A UI shell with a deferred backend isn’t shipped. A migration with no caller isn’t shipped." },
  { scene: "audit", fromSec: 6.5, holdSec: 7, caption: "So I wrote a brutal reality-check: design promised X, the code does Y, do they match — yes, partial, or no." },
];

export const SHIPPED: ScriptLine[] = [
  { scene: "shipped", fromSec: 0.4, holdSec: 6, caption: "What’s actually live: code-aware hybrid RAG. Tree-sitter chunking took code retrieval from 8% to 72%." },
  { scene: "shipped", fromSec: 6.7, holdSec: 6, caption: "A knowledge graph, multi-tenant RLS, missions with nine workflows, 521-plus tests." },
  { scene: "shipped", fromSec: 13, holdSec: 5, caption: "And a source-maturity guard so it never sells a plan as a shipped feature." },
];

export const HALFWIRED: ScriptLine[] = [
  { scene: "halfwired", fromSec: 0.4, holdSec: 6.5, caption: "The closed self-learning loop is half-wired. Twelve skill kinds now have real appliers — that part shipped." },
  { scene: "halfwired", fromSec: 7.2, holdSec: 6, caption: "But the recency router and the auto-apply learning gate are still in progress. I label that yellow, not green." },
];

export const PLANNED: ScriptLine[] = [
  { scene: "planned", fromSec: 0.4, holdSec: 6, caption: "The roadmap is a schema, not infrastructure: graph_nodes and graph_edges in the Postgres I already pay for." },
  { scene: "planned", fromSec: 6.7, holdSec: 7, caption: "A durable mission worker, a self-healing loop, domain packs — all designed, none shipped. I won’t claim them." },
];

export const NORTHSTAR: ScriptLine[] = [
  { scene: "northstar", fromSec: 0.4, holdSec: 6, caption: "The North Star isn’t more features. It’s the brain: a self-growing web of knowledge that proves every change." },
  { scene: "northstar", fromSec: 6.7, holdSec: 7.5, caption: "So the next dispatch isn’t a flashy demo. It’s an eval gate and a durable worker — the unglamorous base everything stands on." },
];

export const RULE: ScriptLine[] = [
  { scene: "rule", fromSec: 0.4, holdSec: 6.5, caption: "The rule I ship by now: a phase is done only when its behavior is observable end-to-end, no further code." },
  { scene: "rule", fromSec: 7.2, holdSec: 6, caption: "If it’s partial, it gets an honest label — on the tracker, in the commit, and on camera." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Auditing your own product is uncomfortable. It’s also the only way the roadmap stays honest." },
  { scene: "outro", fromSec: 5.6, holdSec: 4, caption: "Next: when my AI stops sending text and starts sending UI — how I'd build A2UI." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
